import { adminCompaniesEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiCompanyHandler } from "@/services/shared";
import type { ApiCompanyType, CompanyType } from "@/types";

export const enableCompanyHandler = async (id: number | string): Promise<CompanyType> => {
    const response = await axiosClient.put<{
        company: ApiCompanyType,
        message: string,
    }>(adminCompaniesEndpoints.enable(id));

    return transformApiCompanyHandler(response.data.company);
};
